(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(15120);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 70710:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ LazyReveal; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
"use client";


const DefaultShimmer = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "animate-pulse bg-gray-300 h-6 w-full rounded-lg"
    });
function LazyReveal({ children , shimmer , rootMargin ="0px" , threshold =0.1 , className , onVisible , id , style  }) {
    const { 0: visible , 1: setVisible  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const wrapperRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const observerRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (!wrapperRef.current) return;
        observerRef.current = new IntersectionObserver((entries)=>{
            const entry = entries[0];
            if (entry.isIntersecting) {
                setVisible(true);
                onVisible && onVisible();
                observerRef.current?.disconnect();
            }
        }, {
            rootMargin,
            threshold
        });
        observerRef.current.observe(wrapperRef.current);
        return ()=>{
            observerRef.current?.disconnect();
        };
    }, [
        rootMargin,
        threshold
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        ref: wrapperRef,
        className: className,
        id: id,
        style: style,
        children: visible ? children : shimmer || /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DefaultShimmer, {})
    });
}


/***/ }),

/***/ 47046:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ MetaTagsComp; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59830);





const MetaTagsComp = (props)=>{
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    const currentUrl = "https://www.studies-overseas.com" + (router.asPath || "");
    const { metaTitle , metaDescription , src , keywords , robotsMeta , ogimage , twitterimage , isCustomSchema , schemaJson , jotforms , canonicalUrl , isBlogPage  } = props;
    const structuredJSON = isCustomSchema && schemaJson ? schemaJson : _utils_constants__WEBPACK_IMPORTED_MODULE_4__/* .defaultSchema */ .R4;
    const removeQueryParameters = (url)=>{
        const currentUrl = url;
        const queryIndex = currentUrl.indexOf("?");
        return queryIndex !== -1 ? currentUrl.slice(0, queryIndex) : currentUrl;
    };
    const cleanCanonicalUrl = canonicalUrl ? removeQueryParameters(canonicalUrl) : removeQueryParameters(currentUrl);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                    children: metaTitle
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "description",
                    content: metaDescription
                }),
                keywords && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "keywords",
                    content: keywords
                }),
                robotsMeta && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "robots",
                    content: robotsMeta
                }),
                metaTitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:title",
                    content: metaTitle
                }),
                metaDescription && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:description",
                    content: metaDescription
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:url",
                    content: isBlogPage ? cleanCanonicalUrl : currentUrl
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:type",
                    content: "Organization"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:image",
                    content: ogimage || "https://www.studies-overseas.com/kc_schema_logo.png"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:site_name",
                    content: isBlogPage ? cleanCanonicalUrl : currentUrl
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                    rel: "canonical",
                    href: cleanCanonicalUrl || canonicalUrl
                }),
                src && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                    src: src
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:card",
                    content: "summary_large_image"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:site",
                    content: "@KCOverseasEdu"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:creator",
                    content: "@KCOverseasEdu"
                }),
                metaTitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:title",
                    content: metaTitle
                }),
                metaDescription && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:description",
                    content: metaDescription
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:image",
                    content: twitterimage || "https://www.studies-overseas.com/kc_schema_logo.png"
                }),
                structuredJSON && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                    className: "structured-data-list",
                    type: "application/ld+json",
                    dangerouslySetInnerHTML: {
                        __html: JSON.stringify(structuredJSON)
                    }
                })
            ]
        })
    });
};


/***/ }),

/***/ 54820:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_VisibilitySensorComponent; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react-visibility-sensor/dist/visibility-sensor.js
var visibility_sensor = __webpack_require__(33082);
var visibility_sensor_default = /*#__PURE__*/__webpack_require__.n(visibility_sensor);
// EXTERNAL MODULE: ./node_modules/react-countup/build/index.js
var build = __webpack_require__(17857);
;// CONCATENATED MODULE: ./components/CountUp.tsx


const CountUpComp = (props)=>{
    const { end , suffix  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(build/* default */.ZP, {
        duration: 0.4,
        end: end,
        redraw: true,
        suffix: suffix || "",
        enableScrollSpy: true,
        separator: ","
    });
};
/* harmony default export */ var CountUp = (CountUpComp);

;// CONCATENATED MODULE: ./components/VisibilitySensorComponent.tsx



const VisibilitySensorComponent = (props)=>{
    const { end , suffix  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((visibility_sensor_default()), {
            partialVisibility: true,
            offset: {
                bottom: 10,
                top: 10
            },
            children: ({ isVisible  })=>/*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: isVisible ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CountUp, {
                        end: end,
                        suffix: suffix
                    }) : end
                })
        })
    });
};
/* harmony default export */ var components_VisibilitySensorComponent = (VisibilitySensorComponent);


/***/ }),

/***/ 15120:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./styles/Home.module.scss
var Home_module = __webpack_require__(81673);
var Home_module_default = /*#__PURE__*/__webpack_require__.n(Home_module);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(46066);
// EXTERNAL MODULE: ./node_modules/slick-carousel/slick/slick.css
var slick = __webpack_require__(98322);
// EXTERNAL MODULE: ./node_modules/slick-carousel/slick/slick-theme.css
var slick_theme = __webpack_require__(98745);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(10682);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(34051);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(31555);
// EXTERNAL MODULE: ./components/CustomImage.tsx
var CustomImage = __webpack_require__(45992);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/LazyReveal.tsx
var LazyReveal = __webpack_require__(70710);
;// CONCATENATED MODULE: ./components/HomePageServices.tsx












const settings = {
    dotsClass: (Home_module_default()).sliderDots,
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false
};
const HomePageServices = ({ sectionData  })=>{
    const sliderRef = (0,react.useRef)(null);
    const { servicesTitle , serviceType  } = sectionData;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyReveal/* default */.Z, {
                id: "home-page-services",
                className: "d-none d-sm-block",
                children: serviceType.length > 0 && serviceType.map((singleService, index)=>{
                    const { serviceTitle , serviceDesc , offerings , bgColor , id , seeMoreUrl , imagePath , imageAltTag  } = singleService;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Home_module_default()).home_page_service_div,
                        style: {
                            backgroundColor: bgColor
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                            children: index % 2 === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                                children: [
                                    index === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (Home_module_default()).serviceHead,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            className: "text-center",
                                            children: servicesTitle
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                        xs: 12,
                                        lg: 6,
                                        sm: 6,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (Home_module_default()).service_content,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (Home_module_default()).content,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                            children: serviceTitle
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: serviceDesc
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (Home_module_default()).offers,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                            children: "Offerings"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                            children: offerings.length > 0 && offerings.map((offer, ind)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    children: offer
                                                                }, ind))
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: seeMoreUrl,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                className: (Home_module_default()).serviceAnchor,
                                                                children: "See More"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                        xs: 12,
                                        lg: 6,
                                        sm: 6,
                                        className: "text-center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (Home_module_default()).service_img_slider,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                src: imagePath || `/images/home-page-service-${id}.svg`,
                                                alt: imageAltTag,
                                                width: 375,
                                                height: 424
                                            })
                                        })
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                        xs: 12,
                                        lg: 6,
                                        sm: 6,
                                        className: "text-center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (Home_module_default()).service_img_slider,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                src: imagePath || `/images/home-page-service-${id}.svg`,
                                                alt: imageAltTag,
                                                width: 375,
                                                height: 424
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                        xs: 12,
                                        lg: 6,
                                        sm: 6,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (Home_module_default()).service_content,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (Home_module_default()).content,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                            children: serviceTitle
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: serviceDesc
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (Home_module_default()).offers,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                            children: "Offerings"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                            children: offerings.length > 0 && offerings.map((offer, ind)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    children: offer
                                                                }, ind))
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: seeMoreUrl,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                className: (Home_module_default()).serviceAnchor,
                                                                children: "See More"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        })
                    }, id);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(LazyReveal/* default */.Z, {
                id: "home-page-servicem",
                className: "d-block d-sm-none",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, {
                        ...settings,
                        ref: sliderRef,
                        className: (Home_module_default()).slider,
                        children: serviceType.length > 0 && serviceType.map((singleService, index)=>{
                            const { serviceTitle , serviceDesc , offerings , bgColor , id , seeMoreUrl , imagePath , imageAltTag  } = singleService;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (Home_module_default()).home_page_service_div,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                    className: "text-center mb-5",
                                                    children: servicesTitle
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (Home_module_default()).service_img_slider,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                        src: imagePath || `/images/home-page-service-${id}.svg`,
                                                        alt: imageAltTag,
                                                        width: 220,
                                                        height: 248.75
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (Home_module_default()).service_content,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: (Home_module_default()).content,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                                    children: serviceTitle
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    children: serviceDesc
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: (Home_module_default()).offers,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                    children: "Offerings"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                                    children: offerings.length > 0 && offerings.map((offer, ind)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                            children: offer
                                                                        }, ind))
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                    href: seeMoreUrl,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        children: "See More"
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                })
                            }, index);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Home_module_default()).arrowsClass,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                onClick: ()=>sliderRef?.current?.slickPrev(),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                    src: "/new-images/left-arrow.svg",
                                    alt: "Left Arrow",
                                    height: 17,
                                    width: 10
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                onClick: ()=>sliderRef?.current?.slickNext(),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                    src: "/new-images/right-arrow.svg",
                                    alt: "Right Arrow",
                                    height: 17,
                                    width: 10
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_HomePageServices = (HomePageServices);

// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Button.js
var Button = __webpack_require__(35005);
// EXTERNAL MODULE: ./components/VisibilitySensorComponent.tsx + 1 modules
var VisibilitySensorComponent = __webpack_require__(54820);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./utils/applyCtaButtonProps.ts
var utils_applyCtaButtonProps = __webpack_require__(78409);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./utils/b2c/sourceTracking.ts
var sourceTracking = __webpack_require__(3265);
// EXTERNAL MODULE: ./utils/b2c/constants.ts
var constants = __webpack_require__(90017);
;// CONCATENATED MODULE: ./hooks/useB2cFlag.ts
const B2C_FLAG_KEY = "Enable_B2C_On_Studies_Overseas";
function useB2cFlag() {
    const raw2 = "\"true\"" ?? 0;
    console.log("raw2", raw2, typeof raw2);
    const raw = ("\"true\"" ?? 0).trim().toLowerCase().replace(/^["']|["']$/g, "");
    return raw === "true" || raw === "on" || raw === "1" || raw === "yes";
}

;// CONCATENATED MODULE: ./components/HomepageLanding.tsx





const KCOnlinePlatroms = dynamic_default()(()=>__webpack_require__.e(/* import() */ 8898).then(__webpack_require__.bind(__webpack_require__, 78898)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(78898)
            ]
    }
});
const WebinarEvents = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(2350), __webpack_require__.e(5277)]).then(__webpack_require__.bind(__webpack_require__, 72350)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(72350)
            ]
    },
    ssr: false
});





const FeaturedBlogs = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(3656), __webpack_require__.e(5684), __webpack_require__.e(6107)]).then(__webpack_require__.bind(__webpack_require__, 85684)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(85684)
            ]
    },
    ssr: false
});
const TopTieUpsOfKC = dynamic_default()(()=>__webpack_require__.e(/* import() */ 7761).then(__webpack_require__.bind(__webpack_require__, 97761)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(97761)
            ]
    },
    ssr: false
});
const KcNewLatestUpdates = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(9465), __webpack_require__.e(2579)]).then(__webpack_require__.bind(__webpack_require__, 79465)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(79465)
            ]
    }
});








const KcNews = dynamic_default()(()=>__webpack_require__.e(/* import() */ 2201).then(__webpack_require__.bind(__webpack_require__, 52201)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(52201)
            ]
    }
});
const Homepage = (props)=>{
    const { title , description , coreStrengths: { coreTitle , sections  } , services , advantageTitle , advantageSubTitle , advantageDesc , heroSectionBtn ,  } = props.homePageData;
    const router = (0,next_router.useRouter)();
    const b2cEnabled = useB2cFlag();
    const applyCtaButtonProps = (0,utils_applyCtaButtonProps/* getOnboardingOrFormCtaProps */.J)(router, {
        btnLink: heroSectionBtn?.btnLink,
        formId: heroSectionBtn?.formId,
        toOnboardingEnabled: b2cEnabled && Boolean(heroSectionBtn?.toOnboardingEnabled),
        sourceUrl: "home"
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preload",
                        as: "image",
                        href: props.homePageData.mainImageUrl || "/images/girl.png",
                        imageSrcSet: `${props.homePageData.mainImageUrl || "/images/girl.png"} 640w`,
                        imageSizes: "(max-width: 767px) 640px, 100vw",
                        fetchPriority: "high"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preload",
                        as: "image",
                        href: "/new-palace.png",
                        fetchPriority: "high"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "homepage",
                className: (Home_module_default()).dynamicBg,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Home_module_default()).mainSectionBg,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "/new-palace.png",
                                alt: "",
                                "aria-hidden": "true",
                                className: (Home_module_default()).mainSectionBgBgImage,
                                loading: "eager",
                                fetchPriority: "high",
                                decoding: "async"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                        xs: 12,
                                        lg: 6,
                                        className: "order-lg-2",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            id: "headImg",
                                            className: `${(Home_module_default()).mainContent} text-center`,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (Home_module_default()).heroImageWrapper,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("picture", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                                            media: "(max-width: 767px)",
                                                            srcSet: props.homePageData.newMainImageUrl?.imageUrl || "/images/girl.png"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                                            media: "(min-width: 768px)",
                                                            srcSet: props.homePageData.newMainImageUrl?.imageUrl || "/images/girl.png"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: props.homePageData.newMainImageUrl?.imageUrl || "/images/girl.png",
                                                            alt: props.homePageData.newMainImageUrl?.alt || "Hero image",
                                                            width: "640",
                                                            height: "507",
                                                            className: (Home_module_default()).responsiveHeroImage,
                                                            loading: "eager",
                                                            fetchPriority: "high",
                                                            decoding: "async"
                                                        })
                                                    ]
                                                })
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                        xs: 12,
                                        lg: 6,
                                        className: "order-lg-1",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            id: "headText",
                                            className: (Home_module_default()).mainContent,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                    children: title
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: description
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                    id: "enquirebt",
                                                    variant: "primary",
                                                    size: "lg",
                                                    onClick: (e)=>{
                                                        if (applyCtaButtonProps.mode === "onboarding" && "object" !== "undefined") {
                                                            (0,sourceTracking/* persistSourceContext */.jW)({
                                                                sourceUrl: window.location.href,
                                                                primarySource: constants/* PRIMARY_SOURCE_B2C_WIDGET */.ov,
                                                                fifthStepVisible: heroSectionBtn?.onBoardingFlow?.nearestOffice ?? true,
                                                                coachingVisible: heroSectionBtn?.onBoardingFlow?.lookingForCoaching ?? true
                                                            });
                                                        }
                                                        applyCtaButtonProps.onClick?.(e);
                                                    },
                                                    className: applyCtaButtonProps.formClassName,
                                                    children: heroSectionBtn?.btnTitle ?? "Start Your Journey"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "strengths-core",
                className: (Home_module_default()).Strengths,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                children: coreTitle
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                            id: "core-strenths",
                            className: "text-center",
                            children: sections.length > 0 && sections?.map((section, ind)=>{
                                const { count , sectionTitle , sectionDesc , color , href  } = section;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                    xs: 12,
                                    md: 4,
                                    lg: 4,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (Home_module_default()).StrengthsContent,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                href: href,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                                        style: {
                                                            color: color,
                                                            display: "flex",
                                                            justifyContent: "center"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(VisibilitySensorComponent/* default */.Z, {
                                                                end: count
                                                            }),
                                                            "+"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                        children: sectionTitle
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: sectionDesc
                                            })
                                        ]
                                    })
                                }, ind);
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_HomePageServices, {
                sectionData: services
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(LazyReveal/* default */.Z, {
                className: (Home_module_default()).multiCountry,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                                    id: "multi-countryimage",
                                    xs: 12,
                                    lg: 6,
                                    md: 6,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                            className: "d-block d-sm-none",
                                            children: [
                                                " ",
                                                advantageTitle
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                            src: props?.homePageData?.multicountryImageUrl?.newMultiCountryImage?.imageUrl || "/images/multi-country.svg",
                                            alt: props?.homePageData?.multicountryImageUrl?.newMultiCountryImage?.alt,
                                            width: 535,
                                            height: 599
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                    id: "multi-countrytxt",
                                    xs: 12,
                                    lg: 6,
                                    md: 6,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (Home_module_default()).multi_country_content,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                className: "d-none d-sm-block",
                                                children: advantageTitle
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                children: advantageSubTitle
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: advantageDesc
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                id: "ExploreCountries",
                                                className: `${(Home_module_default()).viewMore}`,
                                                onClick: ()=>window.location.href = "/study-destinations",
                                                children: "Explore Countries"
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        id: "multi-countryimages",
                        className: (Home_module_default()).WebinarHomeLineImg,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                            src: "/new-images/webinar-home-page-line.svg",
                            alt: "webinarHomePageLine.svg",
                            width: 126,
                            height: 87
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyReveal/* default */.Z, {
                className: (Home_module_default()).webinarEventsMianSection,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WebinarEvents, {
                        headingLevel: 2
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyReveal/* default */.Z, {
                className: (Home_module_default()).homePageKcOnlinePlatform,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(KCOnlinePlatroms, {
                    ...props
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyReveal/* default */.Z, {
                className: (Home_module_default()).homepageUniTieUp,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TopTieUpsOfKC, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyReveal/* default */.Z, {
                className: (Home_module_default()).homekcNewLatestUpdate,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(KcNewLatestUpdates, {
                    ...props
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyReveal/* default */.Z, {
                className: (Home_module_default()).homePageBlogs,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturedBlogs, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(KcNews, {
                ...props
            })
        ]
    });
};
/* harmony default export */ var HomepageLanding = (Homepage);

// EXTERNAL MODULE: ./components/MetaTagsComp.tsx
var MetaTagsComp = __webpack_require__(47046);
;// CONCATENATED MODULE: ./pages/index.tsx




const Home = (props)=>{
    const { meta  } = props.homePageData;
    (0,react.useEffect)(()=>{
        const customStyle = document.documentElement.style;
        customStyle.setProperty("--navbar-color", "#226CF5");
        customStyle.setProperty("--navbar-menu-color", "#ffffff");
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            meta && /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaTagsComp/* MetaTagsComp */.r, {
                ...meta
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HomepageLanding, {
                ...props
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var pages = (Home);


/***/ }),

/***/ 81673:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"dynamicBg":"Home_dynamicBg__Oa7bk","mainSectionBg":"Home_mainSectionBg__A9gt6","mobileImgHeight":"Home_mobileImgHeight__Z60sQ","mainContent":"Home_mainContent__xRNLb","contentImgGirl":"Home_contentImgGirl__1cf3x","mainSectionBgBgImage":"Home_mainSectionBgBgImage__DnwAr","Strengths":"Home_Strengths__RKsxE","StrengthsContent":"Home_StrengthsContent__XQ7o6","multiCountry":"Home_multiCountry__qnPs4","multi_country_content":"Home_multi_country_content__IpYuO","viewMore":"Home_viewMore__QL5Gu","WebinarHomeLineImg":"Home_WebinarHomeLineImg__QylnF","home_page_service_div":"Home_home_page_service_div__abSpF","serviceHead":"Home_serviceHead__nke_6","service_content":"Home_service_content__u0y6f","serviceAnchor":"Home_serviceAnchor__VYwFg","service_img_slider":"Home_service_img_slider__Cfgv3","webinarEventsMianSection":"Home_webinarEventsMianSection__w5oOf","homePageKcOnlinePlatform":"Home_homePageKcOnlinePlatform__Jqify","KCOnlinePlatroms":"Home_KCOnlinePlatroms__glDmw","centered":"Home_centered___f9pj","PlatformContent":"Home_PlatformContent__01JL5","platformDivImg":"Home_platformDivImg__qhEjG","platformDivImgMobile":"Home_platformDivImgMobile__p9Qyz","uniTieUp":"Home_uniTieUp__dI5K3","cols":"Home_cols__z_McS","borderl0":"Home_borderl0__qYIXO","border0":"Home_border0__rUKqg","homepageUniTieUp":"Home_homepageUniTieUp__AEIhQ","homePageLatestKcUpdates":"Home_homePageLatestKcUpdates__lEY82","homePageBlogs":"Home_homePageBlogs__IOfQB","sliderDots":"Home_sliderDots__TrjVn","slick-slide":"Home_slick-slide__rPyO0","slider":"Home_slider__SoxcW","homekcNewLatestUpdate":"Home_homekcNewLatestUpdate__BJXyc","arrowsClass":"Home_arrowsClass__JqIvl","kcNews":"Home_kcNews__rqDUy","heading":"Home_heading__5g6vc","col":"Home_col__iXDGx","borderBottomMd":"Home_borderBottomMd__aPuuu","borderBottomSm":"Home_borderBottomSm__8Df4_","borderBottomXs":"Home_borderBottomXs__HmA_i","kcNewsSliderDots":"Home_kcNewsSliderDots__q8A_R","heroImageWrapper":"Home_heroImageWrapper__kLwo_","responsiveHeroImage":"Home_responsiveHeroImage__aeR_X"};

/***/ }),

/***/ 98745:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 98322:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(5443)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6066,5655,9774,2888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);